import React from 'react'

const CheckList: React.FC = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="32"
      height="37"
      viewBox="0 0 32 37"
      fill="none"
    >
      <path
        d="M8.49999 4.33301C5.90666 4.41134 4.36166 4.69967 3.29166 5.76967C1.82666 7.23634 1.82666 9.59467 1.82666 14.313V25.1563C1.82666 29.8763 1.82666 32.2347 3.29166 33.7013C4.75499 35.1663 7.11332 35.1663 11.8267 35.1663H20.16C24.875 35.1663 27.2317 35.1663 28.695 33.6997C30.1616 32.2347 30.1616 29.8763 30.1616 25.1563V14.313C30.1616 9.59634 30.1616 7.23634 28.695 5.76967C27.6267 4.69967 26.08 4.41134 23.4867 4.33301"
        stroke="#53514E"
        strokeWidth="3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M18.5 16.833H24.3333M7.66663 18.4997C7.66663 18.4997 8.49996 18.4997 9.33329 20.1663C9.33329 20.1663 11.98 15.9997 14.3333 15.1663M18.5 26.833H24.3333M9.33329 26.833H11M8.49329 4.74967C8.49329 3.13967 9.79996 1.83301 11.41 1.83301H20.5766C21.3502 1.83301 22.092 2.1403 22.639 2.68728C23.186 3.23426 23.4933 3.97613 23.4933 4.74967C23.4933 5.52322 23.186 6.26509 22.639 6.81207C22.092 7.35905 21.3502 7.66634 20.5766 7.66634H11.41C10.6364 7.66634 9.89455 7.35905 9.34756 6.81207C8.80058 6.26509 8.49329 5.52322 8.49329 4.74967Z"
        stroke="#53514E"
        strokeWidth="3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}

export default CheckList
